import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Layout from '../../components/Layout';
import FacultyProfile from '../../pages/FacultyProfile';
import Loading from '../../components/Base/Loading';

class FacultyProfileContainer extends Component {
  _isMounted = false
  constructor(props) {
    super(props);
    this.id = this.props.match.params.profile;
    this.state = {
      width: 0,
      height: 0,
      loading: false,
      data: null
    };
  }

  componentDidMount() {
    this._isMounted = true
    this.listener = this.fetchProfileListener()
  }

  fetchProfileListener = () => {
    return this.props.firebase.faculty(this.id).onSnapshot(snapshot => {
      let result = { id: snapshot.id, ...snapshot.data() };
      this.setState({ data: { ...result } })
      this.handleSelectStudent(this.id)
    })
  };

  handleSelectStudent = async (id) => {
    this.setState({ loading: true });
    try {
      const { data } = this.state;
      let newData = { ...data };
      this.setState({ data: newData })
    } catch (err) {
    }
    this.setState({ loading: false });
  };

  componentWillUnmount() {
    this.listener()
    this._isMounted = false
  }

  render() {
    const { data, loading } = this.state;

    return (
      <Layout {...this.props} noSideBar noFooter>
        {data === null || loading ? <Loading /> :
          <FacultyProfile {...this.props} data={data} />}
      </Layout>
    );
  }
}


export default withRouter(FacultyProfileContainer);
